export default __webpack_public_path__ + "static/media/hyresvillkor.bdd69e12.pdf";